import { useEffect, useState, useRef } from "react";
import "../../styles/admin/Notifications.css";
import axios from "axios";
import BASE_URL from "../../BaseUrl";
import { useNavigate } from "react-router-dom";
import BackIcon from "../../back icon.svg"

export default function Notifications({setShowNotifications,setCheckNotifications,checkNotifications , isAdmin}) {
  const [notifications, setNotifications] = useState([]);
  const [limit,setLimit] = useState(10);
  const bottomRef = useRef(null);
  const listRef = useRef(null);
  
  const navigate = useNavigate();

  const fetchNotifications = async (l) => {
    await axios.get(`${BASE_URL}/${isAdmin?"teacher":"assistant"}/notifications?limit=${l}`, { withCredentials: true })
    .then((response)=>{
        setNotifications(response.data);
    }).catch((error)=>{
        console.log(error);
    })
  }

  const navigateToNotification = (n)=>{
    if(n.action.includes("درس")|| n.action.includes("إنشاء")){
        navigate(`/${isAdmin?'admin-home':'assistant-home'}/video-details/${n.url.split("|")[0]}`,{state:{courseId:n.url.split("|")[1]}});
    }
    else if(n.action.includes("مادة")){
        isAdmin? navigate(`/admin-home/`): navigate("/assistant-home")
    }
    else if(n.action.includes("مجلد") || n.action.includes("وحدة")){
        navigate(`/admin-home/folder/${n.url.split("|")[0]}`,{state:{courseId:n.url.split("|")[1]}})
    }
    else if(n.action.includes("بيانات")){
      navigate(`/admin-home/admin-assistant-profile/${n.url}`);
    }
    else if(n.action.includes("اختبار")){
      navigate(`/${isAdmin?"admin-home":"assistant-home"}/preview-exam/${n.url}`)
    }
  }

  const handleNotificationClick = async(n)=>{
    if(isAdmin){
      await axios.get(`${BASE_URL}/teacher/read-notification?nId=${n.id}`,{withCredentials:true})
      .catch((error)=>{
        console.log(error);
      });
    } else{
      await axios.get(`${BASE_URL}/assistant/read-notification?nId=${n.id}`,{withCredentials:true})
      .catch((error)=>{
        console.log(error);
      });

    }
    setCheckNotifications(!checkNotifications)
    navigateToNotification(n);
    setShowNotifications(false)
  }
// eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    fetchNotifications(limit);
  }, [limit]);
// eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setLimit((prev) => prev + 20);
        }
      },
      {
        root: listRef.current,
        threshold: 0.2,
      }
    );

    if (bottomRef.current) observer.observe(bottomRef.current);

    return () => observer.disconnect();
  },[]);

  return (
    <div className="page-container">
      <div className="notifications-header"><img className="back-icon" onClick={()=>setShowNotifications(false)} src={BackIcon} alt="back"/><h1 className="page-title">الإشعارات</h1></div>

      <div className="notification-list">
        {notifications.map((n) => {
          return(
          <div key={n.id} className={`notification-card ${n.read? "read" : "unread"}`}
            onClick={()=>handleNotificationClick(n)}
          >
            <h2 className="notification-title">{n.title}</h2>
            <p className="notification-message" dir="rtl" >{n.message}</p>
          </div>
        )})}
        <div ref={bottomRef} className="bottom-trigger"></div>
      </div>
    </div>
  );
}
